import { isVariant } from './is-variant.es.js';

function resolveVariant(definition, variants) {
    if (isVariant(definition)) {
        return definition;
    }
    else if (definition && variants) {
        return variants[definition];
    }
}

export { resolveVariant };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/state/utils/resolve-variant.es.js
// module id = 6SSy
// module chunks = 0